import React from "react";

import Card from "../Card";

import { projectsTitle, projectsData } from "../../data/projectsData";

import { sortByImportance } from "../../utils";

const Projects = ({ activeSection }) => {
  const projects = sortByImportance(projectsData);

  return (
    <section id="projects">
      <h3 className={activeSection === "projects" ? "active" : ""}>
        {projectsTitle}
      </h3>
      <ul>
        {projects.map((el) => (
          <Card
            key={el.key}
            date={el.date}
            title={el.title}
            establishment={el.establishment}
            details={el.details}
            info={el.info}
            skills={el.skills}
            image={el.image}
            links={el.links}
          />
        ))}
      </ul>
    </section>
  );
};

export default Projects;
